// extracted by mini-css-extract-plugin
export default {"selectedAuthors":"authors-edit_selectedAuthors__tz+yd","author":"authors-edit_author__JUhDO","removeAuthorButton":"authors-edit_removeAuthorButton__nVa+I"};